import React, { useContext, useState } from 'react';
import { GlobalContext } from '../../contexts/GlobalContext';
import Breadcrumb from '../../components/Breadcrumb/Breadcrumb';
import PageTitle from '../../components/PageTitle/PageTitle';
import getImage from '../../useFull/getImage';
import InputGroup from '../../components/Form/InputGroup';
import SelectGroup from '../../components/Form/SelectGroup';
import states from '../../lists/states.json'
import Btn from '../../components/Btn/Btn'
import {
    isInvaidNamePerson,
    isInvalidEmail,
    isNotTrim,
    isInvalidContentOfMask
} from '../../useFull/checkValidStrings'
import { GoogleReCaptcha, useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import isEmpty from '../../useFull/isEmpty';
import url from '../../apiUrl';
import axios from 'axios';
import Loading from '../../components/Loading/Loading';
import Alert from '../../components/Alert/Alert';
import './SecurityRelprev.css'

const SecurityRelprev = () => {
    const { state } = useContext(GlobalContext)
    const { executeRecaptcha } = useGoogleReCaptcha();

    const [loadingEmail, setLodingEmail] = useState(false);
    const [cities, setCities] = useState([]);
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [company, setCompany] = useState('');
    const [city, setCity] = useState('');
    const [personState, setPersonState] = useState('');
    const [celPhone, setCelPhone] = useState('');
    const [placeOccurence, setPlaceOccurence] = useState('');
    const [dateTime, setDateTime] = useState('');
    const [peopleInvolved, setPeopleInvolved] = useState('');
    const [airplane, setAirplane] = useState('');
    const [mensage, setMensage] = useState('');
    const [acceptPolicy, setAcceptPolicy] = useState(false);
    const [invalidMsg, setInvalidMsg] = useState({});
    const [sessionEmail, setSessionEmail] = useState(false);
    const [alertMsg, setAlertMsg] = useState();

    const language = state.language || 'pt-br';
    const data = require(`../../assets/languages/${language}/securityRelprev.json`);
    const {
        breadcrumb,
        selectedPage,
        pageTitle,
        pageSubtitle,
        intro,
        form,
        successMsg
    } = data
    const {
        formName,
        formEmail,
        formCompany,
        formCity,
        formState,
        formCelPhone,
        formPlaceOccurence,
        formDate,
        formPeopleInvolved,
        formAirplane,
        formMensage,
        formPolicy,
        formBtn
    } = form

    const handlePersonState = (val) => {
        setPersonState(val.toUpperCase());
        setCity('');
        setInvalidMsg({ ...invalidMsg, [formState.name]: '' });
        const stateCode = val.split(' - ')[0].toUpperCase();
        const foundState = states.find((state) => state.value === stateCode);
        setCities([]);
        setTimeout(() => {
            setCities(foundState ? foundState.cities : []);
        }, 100);
    }

    const handleSendEmail = () => {
        const _invalidMsg = {}

        if (name.length < 5 || isInvaidNamePerson(name)) _invalidMsg[formName.name] = formName.errorMsg
        else if (isNotTrim(name)) _invalidMsg[formName.name] = formName.errorMsg2

        if (email.length < 5 || isInvalidEmail(email.toLocaleLowerCase()) || isNotTrim(email)) _invalidMsg[formEmail.name] = formEmail.errorMsg

        if (company.length < 5) _invalidMsg[formCompany.name] = formCompany.errorMsg
        else if (isNotTrim(company)) _invalidMsg[formCompany.name] = formCompany.errorMsg2

        if (placeOccurence.length < 5) _invalidMsg[formPlaceOccurence.name] = formPlaceOccurence.errorMsg

        if (city.length < 3) _invalidMsg[formCity.name] = formCity.errorMsg
        else if (city.length > 1 && isNotTrim(city)) _invalidMsg[formCity.name] = formCity.errorMsg2

        if (dateTime.length < 16) _invalidMsg[formDate.name] = formDate.errorMsg

        if (!celPhone || isInvalidContentOfMask(celPhone)) _invalidMsg[formCelPhone.name] = formCelPhone.errorMsg

        if (airplane.length && isInvalidContentOfMask(airplane)) _invalidMsg[formAirplane.name] = formAirplane.errorMsg

        if (personState.length < 2) _invalidMsg[formState.name] = formState.errorMsg

        if (mensage.length < 20) _invalidMsg[formMensage.name] = formMensage.errorMsg

        if (isEmpty(_invalidMsg)) {
            setInvalidMsg({})
            sendEmail()
        } else {
            setInvalidMsg(_invalidMsg)
        }

    }

    const setSession = async () => {
        setLodingEmail(true)
        try {
            await axios.post(`${url}/SendNotification/iniciar-sessao`, {}, { withCredentials: true });
        } catch (error) {
            console.log(error);
        }
    };

    const sendEmail = async () => {
        if (!sessionEmail) await setSession();
        else return
        setAlertMsg(null)
        const recaptchaResponse = await executeRecaptcha('submit_form');
        const body = {
            nomeCompleto: name,
            email: email,
            celular: celPhone,
            empresa: company,
            localOcorrencia: placeOccurence,
            cidade: city,
            uf: personState,
            data: dateTime,
            envolvidos: peopleInvolved,
            aeronave: airplane,
            descricao: mensage,
            recaptchaResponse
        }
        try {
            await axios.post(`${url}/SendNotification/enviar-notificacao`, body, { withCredentials: true });
            setSessionEmail(true)
            setLodingEmail(false)
            setAlertMsg({
                msg: successMsg,
                color: "var(--success)",
                iconName: 'success.png'
            })

        } catch (error) {
            setLodingEmail(false);
            const errors = error?.response?.data?.errors;
            let errorMsg = 'Ocorreu um erro, por favor tente novamente.';
            if (errors) {
                const errorMessages = Object.values(errors).flat();
                errorMsg = errorMessages.join(' / ');
            }
            setAlertMsg({
                msg: errorMsg,
                color: "var(--error)",
            });
        }
    }



    return (
        <>
            <Breadcrumb
                beforeRoutes={breadcrumb}
                selectedPage={selectedPage}
                ignoreMgBot={true}
            />
            <div className='main-container'>
                <section className="section-container">
                    <div className='default-title-container'>
                        <PageTitle title={pageTitle} subtitle={pageSubtitle} />
                        <div className='bg-icon' style={{ backgroundImage: `url(${getImage('', 'logo-sipaer.png')})` }} />
                    </div>
                    <span className='mg-bot-50' dangerouslySetInnerHTML={{ __html: intro }}></span>
                    <div className='default-form-container mg-bot-100'>
                        <form action="" onSubmit={handleSendEmail}>

                            <div className='_form-row mg-bot-30'>
                                <InputGroup
                                    id={formName.id}
                                    inputName={formName.name}
                                    label={formName.label}
                                    disabled={loadingEmail || sessionEmail}
                                    inputType={formName.type}
                                    value={name}
                                    errorMsg={invalidMsg[formName.name]}
                                    _function={(val) => {
                                        setName(val.toUpperCase());
                                        setInvalidMsg({ ...invalidMsg, [formName.name]: '' })
                                    }}
                                    className='default-form-1 mg-top-30'
                                />

                                <InputGroup
                                    id={formEmail.id}
                                    inputName={formEmail.name}
                                    label={formEmail.label}
                                    disabled={loadingEmail || sessionEmail}
                                    inputType={formEmail.type}
                                    value={email}
                                    errorMsg={invalidMsg[formEmail.name]}
                                    _function={(val) => {
                                        setEmail(val.toUpperCase());
                                        setInvalidMsg({ ...invalidMsg, [formEmail.name]: '' })
                                    }}
                                    className='default-form-1 mg-top-30'
                                />

                                <InputGroup
                                    id={formCelPhone.id}
                                    inputName={formCelPhone.name}
                                    label={formCelPhone.label}
                                    disabled={loadingEmail || sessionEmail}
                                    inputType={formCelPhone.type}
                                    placeholder={formCelPhone.placeholder}
                                    mask={formCelPhone.mask}
                                    value={celPhone}
                                    errorMsg={invalidMsg[formCelPhone.name]}
                                    _function={(val) => {
                                        setCelPhone(val.toUpperCase());
                                        setInvalidMsg({ ...invalidMsg, [formCelPhone.name]: '' })
                                    }}
                                    className='default-form-1 mg-top-30'
                                />

                                <InputGroup
                                    id={formCompany.id}
                                    inputName={formCompany.name}
                                    label={formCompany.label}
                                    disabled={loadingEmail || sessionEmail}
                                    inputType={formCompany.type}
                                    value={company}
                                    errorMsg={invalidMsg[formCompany.name]}
                                    _function={(val) => {
                                        setCompany(val.toUpperCase());
                                        setInvalidMsg({ ...invalidMsg, [formCompany.name]: '' })
                                    }}
                                    className='default-form-1 mg-top-30'
                                />

                                <InputGroup
                                    id={formPlaceOccurence.id}
                                    inputName={formPlaceOccurence.name}
                                    label={formPlaceOccurence.label}
                                    disabled={loadingEmail || sessionEmail}
                                    inputType={formPlaceOccurence.type}
                                    value={placeOccurence}
                                    errorMsg={invalidMsg[formPlaceOccurence.name]}
                                    _function={(val) => {
                                        setPlaceOccurence(val.toUpperCase());
                                        setInvalidMsg({ ...invalidMsg, [formPlaceOccurence.name]: '' })
                                    }}
                                    className='default-form-1 mg-top-30'
                                />

                                {/* <InputGroup
                                    id={formCity.id}
                                    inputName={formCity.name}
                                    label={formCity.label}
                                    disabled={loadingEmail || sessionEmail}
                                    inputType={formCity.type}
                                    value={city}
                                    errorMsg={invalidMsg[formCity.name]}
                                    _function={(val) => {
                                        setCity(val.toUpperCase());
                                        setInvalidMsg({ ...invalidMsg, [formCity.name]: '' })
                                    }}
                                    className='default-form-2 mg-top-30'
                                /> */}

                                <SelectGroup
                                    id={formState.id}
                                    inputName={formState.name}
                                    label={formState.label}
                                    disabled={loadingEmail || sessionEmail}
                                    value={personState}
                                    errorMsg={invalidMsg[formState.name]}
                                    _function={handlePersonState}
                                    options={states}
                                    className='default-form-3 mg-top-30'
                                />

                                {cities?.length ? (
                                    <SelectGroup
                                        id={formCity.id}
                                        inputName={formCity.name}
                                        label={formCity.label}
                                        disabled={loadingEmail || sessionEmail || !cities?.length}
                                        inputType={formCity.type}
                                        value={city}
                                        errorMsg={invalidMsg[formCity.name]}
                                        _function={(val) => {
                                            setCity(val.toUpperCase());
                                            setInvalidMsg({ ...invalidMsg, [formCity.name]: '' })
                                        }}
                                        options={cities}
                                        className="default-form-2 mg-top-30"
                                        isUpper={true}
                                    />
                                ) : (
                                    <InputGroup
                                        id={formCity.id}
                                        inputName={formCity.name}
                                        label={formCity.label}
                                        disabled={true}
                                        inputType={formCity.type}
                                        value={city}
                                        errorMsg={invalidMsg[formCity.name]}
                                        _function={(val) => {
                                            setCity(val.toUpperCase());
                                            setInvalidMsg({ ...invalidMsg, [formCity.name]: '' })
                                        }}
                                        className="default-form-2 mg-top-30"
                                    />
                                )}

                                <InputGroup
                                    id={formDate.id}
                                    inputName={formDate.name}
                                    label={formDate.label}
                                    disabled={loadingEmail || sessionEmail}
                                    inputType={formDate.type}
                                    value={dateTime}
                                    errorMsg={invalidMsg[formDate.name]}
                                    _max={new Date().toISOString().slice(0, 19)}
                                    _function={(val) => {
                                        setDateTime(val.toUpperCase());
                                        setInvalidMsg({ ...invalidMsg, [formDate.name]: '' })
                                    }}
                                    className='default-form-4 mg-top-30 hide-placeholder _form-date-time'
                                />

                                <InputGroup
                                    id={formPeopleInvolved.id}
                                    inputName={formPeopleInvolved.name}
                                    label={formPeopleInvolved.label}
                                    disabled={loadingEmail || sessionEmail}
                                    inputType={formPeopleInvolved.type}
                                    value={peopleInvolved}
                                    errorMsg={invalidMsg[formPeopleInvolved.name]}
                                    placeholder='1234'
                                    _function={(val) => {
                                        setPeopleInvolved(val.toUpperCase());
                                    }}
                                    className='default-form-1 mg-top-30 hide-placeholder'
                                />

                                <InputGroup
                                    id={formAirplane.id}
                                    inputName={formAirplane.name}
                                    label={formAirplane.label}
                                    disabled={loadingEmail || sessionEmail}
                                    inputType={formAirplane.type}
                                    value={airplane}
                                    mask={formAirplane.mask}
                                    errorMsg={invalidMsg[formAirplane.name]}
                                    _function={(val) => {
                                        setAirplane(val.toUpperCase());
                                        setInvalidMsg({ ...invalidMsg, [formAirplane.name]: '' })
                                    }}
                                    className='default-form-5 mg-top-15 _form-airplane'
                                />

                                <InputGroup
                                    id={formMensage.id}
                                    inputName={formMensage.name}
                                    label={formMensage.label}
                                    disabled={loadingEmail || sessionEmail}
                                    inputType={formMensage.type}
                                    value={mensage}
                                    errorMsg={invalidMsg[formMensage.name]}
                                    _function={(val) => {
                                        setMensage(val.toUpperCase());
                                        setInvalidMsg({ ...invalidMsg, [formMensage.name]: '' })
                                    }}
                                    className='w-100 mg-top-30'
                                    isTextArea={true}
                                />
                                <GoogleReCaptcha />
                            </div>

                        </form>
                        <div className={`default-policy-container ${alertMsg && 'mg-bot-30'}`}>
                            <div className={`_form-control ${(loadingEmail || sessionEmail) && '_form-control-disabled'}`}>
                                <input
                                    type="checkbox"
                                    id={formPolicy.id}
                                    name={formPolicy.name}
                                    className='_checkbox'
                                    checked={acceptPolicy}
                                    disabled={loadingEmail || sessionEmail}
                                    onChange={() => setAcceptPolicy(!acceptPolicy)}
                                />
                                <label htmlFor={formPolicy.id} dangerouslySetInnerHTML={{ __html: formPolicy.label }}>
                                </label>
                            </div>
                            {loadingEmail ? (
                                <div className='default-policy-container-loading'>
                                    <Loading />
                                </div>

                            ) : (
                                <Btn
                                    label={formBtn.label}
                                    disabled={!name || !email || !company || !placeOccurence || !city || !personState || !dateTime || !celPhone || !mensage || !acceptPolicy || sessionEmail}
                                    className='default-form-btn'
                                    _function={handleSendEmail}
                                />
                            )}
                        </div>

                        {alertMsg && (
                            <Alert msg={alertMsg.msg} color={alertMsg.color} ignorable={true} _requestClose={() => setAlertMsg(null)} iconName={alertMsg.iconName} />
                        )}
                    </div>
                </section>
            </div>
        </>
    )
}

export default SecurityRelprev